import Super from '@simplepractice/ember-messaging-client/adapters/messaging-user';

export default Super.extend({});
